module.exports = __webpack_public_path__ + "static/icons/icon-map--white-9e37044e1c35faf39b0edf7970119437.svg";